import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';

import Modal from '@/components/library/Modal.vue';
Vue.component('Modal', Modal);
import Acabados from '@/components/library/Acabados.vue';
Vue.component('Acabados', Acabados);
import Carousel from '@/components/library/Carousel.vue';
Vue.component('Carousel', Carousel);
import Divider from '@/components/library/Divider.vue';
Vue.component('Divider', Divider);
import Info from '@/components/library/Info.vue';
Vue.component('Info', Info);
import Input from '@/components/library/Input.vue';
Vue.component('Input', Input);
import Select from '@/components/library/Select.vue';
Vue.component('Select', Select);
import Slider from '@/components/library/Slider.vue';
Vue.component('Slider', Slider);
import Tabs from '@/components/library/Tabs.vue';
Vue.component('Tabs', Tabs);
import Toggle from '@/components/library/Toggle.vue';
Vue.component('Toggle', Toggle);
import Button from '@/components/library/Button.vue';
Vue.component('Button', Button);

import errorAsset from '@/assets/images/errorAsset.svg';
import literales from '@/assets/backend/literales.json';

Vue.mixin({
  methods: {
    resolveAsset(e) {
      var element;
      if (e.target == null || e.target == undefined) {
        element = e.path[0];
      } else {
        element = e.target;
      }

      element.style.opacity = 1;
    },
    requireAsset(path) {
      var asset;
      try {
        asset = require('@/assets/images/' + path);
      } catch (error) {
        asset = errorAsset;
        console.log('%c' + '@/assets/images/' + path, 'color:red');
      }
      return asset;
    },
    getLiteral(cod) {
      const lang = this.$store.getters.getLanguage;
      return (
        cod
          .split('.')
          .reduce(
            (acc, key) => (acc && acc[key] ? acc[key] : null),
            literales
          )?.[lang] || '[' + cod + '-' + lang + ']'
      );
    },
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
